<template>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M 12,4.5c2.899,0,5.25,2.351,5.25,5.25S14.899,15,12,15s-5.25-2.351-5.25-5.25S9.101,4.5,12,4.5z "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 18.913,20.876c-3.794-3.818-9.965-3.837-13.783-0.043c-0.014,0.014-0.029,0.029-0.043,0.043 "
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M 12,0.75 c6.213,0,11.25,5.037,11.25,11.25S18.213,23.25,12,23.25S0.75,18.213,0.75,12S5.787,0.75,12,0.75z"
      class="fill-none"
      :style="[strokeStyle]"
      stroke-linecap="round"
      stroke-linejoin="round"
      v-if="circleVisible"
    />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;

export default {
  name: "IconProfile",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {},
  computed: {
    circleVisible() {
      return this.settings.circle !== undefined ? this.settings.circle : true;
    }
  }
};
</script>